import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

const data = [
  {
    title: '1',
    img: '1.jpg',
  },
  {
    title: '2',
    img: '2.jpg',
  },
  {
    title: '3',
    img: '3.jpg',
  },
  {
    title: '4',
    img: '4.jpg',
  },
  {
    title: '5',
    img: '5.jpg',
  },
  {
    title: '6',
    img: '6.jpg',
  },
]

export default function Quality () {
  const { t: ti } = useTranslation('info')

  return (
    <div className={styles.root}>
      <h2 className={styles.root__title}>{ti('quality.title')}</h2>

      <div className={styles.root__grid}>
        {data.map((item, index) => {
          return (
            <div className={styles.root__item} key={index}>
              <h3 className={styles.root__subtitle}>
                {ti(`quality.${item.title}`)}
              </h3>
              <img
                className={styles.root__img}
                src={`/img/quality/${item.img}`}
                alt=""
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
